export default function Humidity() {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M16 6.3457L21.66 11.9957C23.22 13.5557 24 15.6357 24 17.6357C24 19.6357 23.22 21.7457 21.66 23.3057C20.1 24.8657 18.05 25.6557 16 25.6557C13.95 25.6557 11.9 24.8657 10.34 23.3057C8.78 21.7457 8 19.6357 8 17.6357C8 15.6357 8.78 13.5557 10.34 11.9957L16 6.3457ZM11.76 13.5957C10.62 14.7257 10.01 15.9957 10 17.9957H22C21.99 15.9957 21.38 14.7657 20.24 13.6457L16 9.2657L11.76 13.5957Z" fill="white" />
        </svg>
    )
}